/** Links into DIM Atlas (dim-tools-atlas), the map of the knowledge graph, served by its own app at /atlas/. */
import routes from '@config/routes';

const DATA = 'https://data.banenor.no/data/';

/**
 * Atlas with the entity selected, as its share links write it (docs/urls.md in dim-tools-atlas): `sel=bnd:<local
 * name>` for DIM data, the full IRI otherwise, with %, , and ; escaped.
 */
export function atlasLink(iri: string): string {
  const id = iri.startsWith(DATA) ? `bnd:${iri.slice(DATA.length)}` : iri;
  const item = encodeURIComponent(id).replace(/%2F/g, '/').replace(/%3A/g, ':');
  return `${routes.atlas}#sel=${item}`;
}
